import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Landmark, Sparkles, Users } from "lucide-react";

const SERVICES = [
  {
    icon: Landmark,
    title: "Personal Loans",
    range: "$5,000 – $150,000",
    body:
      "Consolidate debt, fund a life event, or unlock capital for what matters — fixed-rate personal financing with white-glove underwriting.",
  },
  {
    icon: BadgeCheck,
    title: "Business Loans",
    range: "$25,000 – $500,000",
    body:
      "Working capital, expansion and equipment financing structured around your revenue cycle — decisions delivered in hours, not weeks.",
  },
  {
    icon: Sparkles,
    title: "Auto Financing",
    range: "$10,000 – $200,000",
    body:
      "Refinance existing loans or purchase your next vehicle with concierge-tier rates and a paperless close in under 24 hours.",
  },
  {
    icon: Users,
    title: "Debt Consolidation",
    range: "Up to $100,000",
    body:
      "Roll high-interest balances into a single predictable payment — engineered to lower your APR and reclaim monthly cashflow.",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <div className="grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Services</div>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight sm:text-5xl">
            Financing crafted around <span className="italic text-[#D4AF37]">how you live.</span>
          </h2>
        </div>
        <p className="text-sm text-white/60 lg:col-span-5">
          Four core facilities, each engineered for a specific outcome. Every product is available to
          qualified U.S. residents nationwide.
        </p>
      </div>

      <div className="mt-16 grid gap-6 md:grid-cols-2">
        {SERVICES.map((s) => (
          <div
            key={s.title}
            data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
            className="group relative border border-white/10 bg-white/[0.02] p-8 transition-all hover:border-[#D4AF37]/60 hover:bg-white/[0.04]"
          >
            <div className="flex items-center justify-between">
              <div className="flex h-12 w-12 items-center justify-center border border-[#D4AF37]/60">
                <s.icon className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
              </div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-white/50">{s.range}</div>
            </div>
            <h3 className="mt-8 font-serif text-2xl font-light text-white sm:text-3xl">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">{s.body}</p>
            <Link
              to="/apply"
              className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-[#D4AF37] transition-colors group-hover:text-[#F3E5AB]"
            >
              Apply Now <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
